import { put, call, takeEvery, select, all } from "redux-saga/effects";
import _ from 'lodash';
import moment from 'moment-timezone';
import { APP, ENDPOINT } from "../constants";

import {
    setSeasonData,
    setMissionData,
    setTagSavingLoader,
    setSelectedTag,
    setCommentSavingLoader,
    setAssetComment,
    setSelectedReportTag,
    setSelectedTagNtt,
} from '../actions';

import {
    getJwtToken,
    getDataFromKpiDash,
} from '../api';

export const startDate = state => state.app.dateRange[0];
export const endDate = state => state.app.dateRange[1];
export const selectedTag = state => state.app.selectedTag;
export const assetComment = state => state.app.assetComment;
export const selectedReportTag = state => state.app.selectedReportTag;
export const selectedTagNtt = state => state.app.selectedTagNtt;

const keywords = ["当別町", "苫前町", "体験ミッション"];

const getLocalStorageItem = (key) => {
  return localStorage.getItem(key);
};

export function* handleSeasonData() {
  try {
    const jwtToken = yield call(getJwtToken);
    let loading = "loading";
    let dateFrom = yield select(startDate);
    dateFrom = moment(dateFrom).tz("Asia/Tokyo").format("YYYY-MM-DD");
    let dateTo = yield select(endDate);
    dateTo = moment(dateTo).tz("Asia/Tokyo").format("YYYY-MM-DD");

    const sqlQueryGetSeason = {
      query: `
        SELECT gs.id           AS 'seasonId'
            ,sn.official_name  AS 'seasonName'
            ,gt.start_datetime AS 'seasonStart'
            ,gt.end_datetime   AS 'seasonEnd'
            ,sn.abbreviation_name AS 'seasonAbbreviation'
        FROM game_space gs
        INNER JOIN game_term gt ON gt.id = gs.game_term_id
        INNER JOIN season_name sn ON sn.season_id = gs.id AND sn.language_code = 'JA'
        ORDER BY gt.start_datetime DESC
      `,
    };
    const [dataSeasonDataTemp] =
      yield all([
        call(
          getDataFromKpiDash,
          sqlQueryGetSeason,
          ENDPOINT.GET_DATA_API_REPLICA
        ),
      ]);

    const seasonData = JSON.parse(dataSeasonDataTemp.body);
    let seasons = [], seasonObj = {};
    if (localStorage.getItem('access_key') === "qf70ypdjdzm89ypqvc4r7nf9") {
      // ntt
      _.each(seasonData, function(s) {
        if (s.seasonId === "cmadtlnih0001n3mx1wvl9zog" || // aomori
          s.seasonId === "cmd5oyfft0001iho10o2iceha" || // iwate
          s.seasonId === "cmb68qvei00011vo0e591229z" || // hokkaido
          s.seasonId === "cmg7iw3va00017bow596s39cs" || // nagano
          s.seasonId === "cmg7iw3vc00037bowekjy65pc" // tochigi
        ) {
          seasonObj.seasonId = s.seasonId;
          seasonObj.seasonName = s.seasonName;
          seasonObj.seasonStart = s.seasonId === "cmb68qvei00011vo0e591229z"
            ? moment("2025-08-09T00:00:00.000Z").tz("Asia/Tokyo").format("YYYY-MM-DD HH:mm")
            : moment(s.seasonStart).tz("Asia/Tokyo").format("YYYY-MM-DD HH:mm");
          seasonObj.seasonEnd = moment(s.seasonEnd).tz("Asia/Tokyo").format("YYYY-MM-DD HH:mm");
          seasonObj.seasonAbbr = s.seasonAbbreviation;
          seasons.push(seasonObj);
          seasonObj = {};
        }
      });
    } else if (localStorage.getItem('access_key') === "lqdp4c7fuwgfz89og7q4x9f3") {
      // hokuden
      _.each(seasonData, function(s) {
        if (
          s.seasonId === "cmc9114580001sapdecondxjw" ||
          s.seasonId === "cmb68qvei00011vo0e591229z") { // hokkaido battle
          seasonObj.seasonId = s.seasonId;
          seasonObj.seasonName = s.seasonName;
          seasonObj.seasonStart = moment(s.seasonStart).tz("Asia/Tokyo").format("YYYY-MM-DD HH:mm");
          seasonObj.seasonEnd = moment(s.seasonEnd).tz("Asia/Tokyo").format("YYYY-MM-DD HH:mm");
          seasonObj.seasonAbbr = s.seasonAbbreviation;
          seasons.push(seasonObj);
          seasonObj = {};
        }
      });
    } else if (localStorage.getItem('access_key') === "z7n3q9m1x4p2v0ydk8twr5fb") {
      // ntt-ft
      _.each(seasonData, function(s) {
        if (
          s.seasonId === "cmdg2z05f0001e6o0dd8o9g9d") { // NTT FT Poc
          seasonObj.seasonId = s.seasonId;
          seasonObj.seasonName = s.seasonName;
          seasonObj.seasonStart = moment("2025-07-28 00:00").tz("Asia/Tokyo").format("YYYY-MM-DD HH:mm");
          seasonObj.seasonEnd = moment("2025-08-21 23:59").tz("Asia/Tokyo").format("YYYY-MM-DD HH:mm");
          seasonObj.seasonAbbr = s.seasonAbbreviation;
          seasons.push(seasonObj);
          seasonObj = {};
        }
      });
    } else {
      _.each(seasonData, function(s) {
        if (s.seasonId !== "clxvw56es00005soo28mj4jfs" &&
          s.seasonId !== "cm46zidp10001bpp63r3cfhwx" && // akita 1
          s.seasonId !== "cm64mqm94000br3n0esu8c0n4" && // kitakanto
          s.seasonId !== "cm46zidp30003bpp6cxq101mo" &&
          s.seasonId !== "cmadtlnih0001n3mx1wvl9zog" && // aomori
          s.seasonId !== "cmb68qvei00011vo0e591229z" && // hokkaido
          s.seasonId !== "cmc9114580001sapdecondxjw" &&// hokkaido
          s.seasonId !== "cmd5oyfft0001iho10o2iceha" &&// iwate
          s.seasonId !== "cmg7iw3va00017bow596s39cs" && // nagano
          s.seasonId !== "cmg7iw3vc00037bowekjy65pc" // tochigi
        ) {
          seasonObj.seasonId = s.seasonId;
          seasonObj.seasonName = s.seasonName;
          seasonObj.seasonStart = moment(s.seasonStart).tz("Asia/Tokyo").format("YYYY-MM-DD HH:mm");
          seasonObj.seasonEnd = moment(s.seasonEnd).tz("Asia/Tokyo").format("YYYY-MM-DD HH:mm");
          seasonObj.seasonAbbr = s.seasonAbbreviation;
          seasons.push(seasonObj);
          seasonObj = {};
        }
      });
    }
    seasons.sort((a, b) => {
      return moment(b.seasonStart, "YYYY-MM-DD HH:mm").valueOf() -
            moment(a.seasonStart, "YYYY-MM-DD HH:mm").valueOf();
    });
    console.log("LOG seasons:", seasons);
    yield put(setSeasonData(seasons));
  } catch (error) {
    console.log(error);
  }
}

export function* handleMissionData(action) {
  try {
    const jwtToken = yield call(getJwtToken);
    let loading = "loading";
    let dateFrom = yield select(startDate);
    dateFrom = moment(dateFrom).tz("Asia/Tokyo").format("YYYY-MM-DD");
    let dateTo = yield select(endDate);
    dateTo = moment(dateTo).tz("Asia/Tokyo").format("YYYY-MM-DD");
    const isDeaAdmin = action.payload;

    const missionNameQuery =
      !isDeaAdmin
        ? "WHERE " + keywords.map(k => `mn.name NOT LIKE '%${k}%'`).join(" AND ")
        : "";

    const sqlQueryGetMission = {
      query: `
        SELECT gs.id          AS 'missionId'
            ,mn.name           AS 'missionName'
            ,gt.start_datetime AS 'missionStart'
            ,gt.end_datetime   AS 'missionEnd'
        FROM game_space gs
        INNER JOIN game_term gt
        ON gt.id = gs.game_term_id
        INNER JOIN mission m
        ON gs.id = m.id
        INNER JOIN mission_name mn
        ON mn.mission_id = m.id AND mn.language_code = 'JA'
        ${missionNameQuery}
        ORDER BY gt.start_datetime ASC
      `,
    };
    const [dataMissionDataTemp] =
      yield all([
        call(
          getDataFromKpiDash,
          sqlQueryGetMission,
          ENDPOINT.GET_DATA_API_REPLICA
        ),
      ]);

    const missionData = JSON.parse(dataMissionDataTemp.body);
    let missions = [], missionObj = {};
    _.each(missionData, function(m) {
      if (m.missionId !== "cm0zde85z000407506byxr3bu" &&
        m.missionName !== "京都スタンプラリー" &&
        m.missionName.indexOf("動作確認") === -1 &&
        m.missionName.indexOf("建物撮影") === -1
      ) {
        missionObj.missionId = m.missionId;
        missionObj.missionName = m.missionName;
        missionObj.missionStart = moment(m.missionStart).tz("Asia/Tokyo").format("YYYY-MM-DD HH:mm");
        missionObj.missionEnd = moment(m.missionEnd).tz("Asia/Tokyo").format("YYYY-MM-DD HH:mm");
        missions.push(missionObj);
        missionObj = {};
      }
    });
    missions.reverse();
    yield put(setMissionData(missions));
  } catch (error) {
    console.log(error);
  }
}

export function* handleSetSavedTagData() {
  try {
    const env = process.env.REACT_APP_ENV;
    const jwtToken = yield call(getJwtToken);
    yield put(setTagSavingLoader(true));
    const savingTag = yield select(selectedTag);

    const now = new Date();
    const utcDateTime = now.toISOString().slice(0, 19).replace('T', ' ');
    const fileName = savingTag.fileName; //savingTag.fileName.split(".")[0];
    const objectKey = savingTag.object_key;
    const occurredDatetime = savingTag.occurred_datetime.slice(0, 19).replace('T', ' ');
    const gameSpaceId = savingTag.game_space_id;
    const gameSpaceType = savingTag.game_space_type;
    const reviewRequestId = savingTag.review_request_id;
    const photoOfPowerAssetId = savingTag.photo_of_power_asset_id;
    const placeCode = savingTag.place_code;
    const signNumber = savingTag.sign_number;
    const equipmentNumber = savingTag.equipment_number;
    const playerId = savingTag.player_id;
    const playerName = savingTag.player_name;
    const tagArryString = JSON.stringify(savingTag.tags);
    const tagCommaString = savingTag.tags.map(String).join(',');
    const username = yield call(getLocalStorageItem, 'username');
    const email = yield call(getLocalStorageItem, 'email');

    const table = env === 'prod' ? "PicTreeViewerTagProd" : "PicTreeViewerTagDev";
    const sqlQueryGetTag = {
      query: `
        SELECT * FROM ${table} WHERE user_email = '${email}' AND file_name = '${fileName}';
      `,
      type: "select"
    };

    const [getTagDataTemp] =
      yield all([
        call(
          getDataFromKpiDash,
          sqlQueryGetTag,
          ENDPOINT.GET_DATA_KPIDASH_API
        ),
      ]);

    if (getTagDataTemp.length > 0) {
      // UPDATE
      const sqlQueryUpdateTag = {
        query: `
          UPDATE ${table}
          SET tag_array = '${tagArryString}', tag_flat = '${tagCommaString}', logDate = '${utcDateTime}'
          WHERE user_email = '${email}' AND file_name = '${fileName}';
        `,
        type: "write"
      };
      const [updateTagDataTemp] =
        yield all([
          call(
            getDataFromKpiDash,
            sqlQueryUpdateTag,
            ENDPOINT.GET_DATA_KPIDASH_API
          ),
        ]);
      console.log("LOG updateTagDataTemp:", updateTagDataTemp);
    } else {
      // INSERT
      const sqlQuerySetTag = {
        query: `
          INSERT INTO ${table}
          (user_id, user_email, file_name, object_key, occurred_datetime, game_space_id, game_space_type, review_request_id, photo_of_power_asset_id, place_code, sign_number, equipment_number, player_id, player_name, tag_array, tag_flat, private, logDate) VALUES ('${username}', '${email}', '${fileName}', '${objectKey}', '${occurredDatetime}', '${gameSpaceId}', '${gameSpaceType}','${reviewRequestId}', '${photoOfPowerAssetId}', '${placeCode}', '${signNumber}','${equipmentNumber}', '${playerId}', '${playerName}', '${tagArryString}', '${tagCommaString}', 0, '${utcDateTime}');
        `,
        type: "write"
      };
      console.log("LOG sqlQuerySetTag:", sqlQuerySetTag.query);
      const [setTagDataTemp] =
        yield all([
          call(
            getDataFromKpiDash,
            sqlQuerySetTag,
            ENDPOINT.GET_DATA_KPIDASH_API
          ),
        ]);
      console.log("LOG setTagDataTemp:", setTagDataTemp);
    }
    yield put(setTagSavingLoader(false));
  } catch (error) {
    console.log(error);
  }
}

export function* handleGetSavedTagDataByFileName(action) {
  try {
    const env = process.env.REACT_APP_ENV;
    const email = yield call(getLocalStorageItem, 'email');
    const fileName = action.payload;
    const table = env === 'prod' ? "PicTreeViewerTagProd" : "PicTreeViewerTagDev";
    const sqlQueryGetTag = {
      query: `
        SELECT * FROM ${table} WHERE user_email = '${email}' AND file_name = '${fileName}';
      `,
      type: "select"
    };
    const [getTagDataTemp] =
      yield all([
        call(
          getDataFromKpiDash,
          sqlQueryGetTag,
          ENDPOINT.GET_DATA_KPIDASH_API
        ),
      ]);
    if (getTagDataTemp.length > 0) {
      const savedTagData = {
        fileName: getTagDataTemp[0][3]["stringValue"], //row.fileName
        tags: JSON.parse(getTagDataTemp[0][15]["stringValue"]),  // Array of selected tags
      }
      yield put(setSelectedTag(savedTagData));
    }
    yield put(setTagSavingLoader(false));
  } catch (error) {
    console.log(error);
  }
}

export function* handleSetSavedCommentData() {
  try {
    const env = process.env.REACT_APP_ENV;
    yield put(setCommentSavingLoader(true));
    const savingComment = yield select(assetComment);

    const now = new Date();
    const utcDateTime = now.toISOString().slice(0, 19).replace('T', ' ');
    const fileName = savingComment.fileName;
    const objectKey = savingComment.object_key;
    const occurredDatetime = savingComment.occurred_datetime.slice(0, 19).replace('T', ' ');
    const gameSpaceId = savingComment.game_space_id;
    const gameSpaceType = savingComment.game_space_type;
    const reviewRequestId = savingComment.review_request_id;
    const photoOfPowerAssetId = savingComment.photo_of_power_asset_id;
    const placeCode = savingComment.place_code;
    const signNumber = savingComment.sign_number;
    const equipmentNumber = savingComment.equipment_number;
    const playerId = savingComment.player_id;
    const playerName = savingComment.player_name;
    const comment = savingComment.comment;
    const username = yield call(getLocalStorageItem, 'username');
    const email = yield call(getLocalStorageItem, 'email');

    const table = env === 'prod' ? "PicTreeViewerCommentProd" : "PicTreeViewerCommentDev";
    const sqlQueryGetComment = {
      query: `
        SELECT * FROM ${table} WHERE user_email = '${email}' AND file_name = '${fileName}';
      `,
      type: "select"
    };

    const [getCommentDataTemp] =
      yield all([
        call(
          getDataFromKpiDash,
          sqlQueryGetComment,
          ENDPOINT.GET_DATA_KPIDASH_API
        ),
      ]);

    if (getCommentDataTemp.length > 0) {
      // UPDATE
      const sqlQueryUpdateComment = {
        query: `
          UPDATE ${table}
          SET comment = '${comment}', logDate = '${utcDateTime}'
          WHERE user_email = '${email}' AND file_name = '${fileName}';
        `,
        type: "write"
      };
      const [updateCommentDataTemp] =
        yield all([
          call(
            getDataFromKpiDash,
            sqlQueryUpdateComment,
            ENDPOINT.GET_DATA_KPIDASH_API
          ),
        ]);
    } else {
      // INSERT
      const sqlQuerySetComment = {
        query: `
          INSERT INTO ${table}
          (user_id, user_email, file_name, object_key, occurred_datetime, game_space_id, game_space_type, review_request_id, photo_of_power_asset_id, place_code, sign_number, equipment_number, player_id, player_name, comment, private, logDate) VALUES ('${username}', '${email}', '${fileName}', '${objectKey}', '${occurredDatetime}', '${gameSpaceId}', '${gameSpaceType}','${reviewRequestId}', '${photoOfPowerAssetId}', '${placeCode}', '${signNumber}','${equipmentNumber}', '${playerId}', '${playerName}', '${comment}', 0, '${utcDateTime}');
        `,
        type: "write"
      };
      console.log("LOG sqlQuerySetComment:", sqlQuerySetComment.query);
      const [setCommentDataTemp] =
        yield all([
          call(
            getDataFromKpiDash,
            sqlQuerySetComment,
            ENDPOINT.GET_DATA_KPIDASH_API
          ),
        ]);
      console.log("LOG setCommentDataTemp:", setCommentDataTemp);
    }
    yield put(setCommentSavingLoader(false));
  } catch (error) {
    console.log(error);
  }
}

export function* handleGetSavedCommentDataByFileName(action) {
  try {
    const env = process.env.REACT_APP_ENV;
    const email = yield call(getLocalStorageItem, 'email');
    const fileName = action.payload;
    const table = env === 'prod' ? "PicTreeViewerCommentProd" : "PicTreeViewerCommentDev";
    const sqlQueryGetTag = {
      query: `
        SELECT * FROM ${table} WHERE user_email = '${email}' AND file_name = '${fileName}';
      `,
      type: "select"
    };
    const [getCommentDataTemp] =
      yield all([
        call(
          getDataFromKpiDash,
          sqlQueryGetTag,
          ENDPOINT.GET_DATA_KPIDASH_API
        ),
      ]);
    if (getCommentDataTemp.length > 0) {
      yield put(setAssetComment(getCommentDataTemp[0][15]["stringValue"])); // Fill up
    }
  } catch (error) {
    console.log(error);
  }
}

export function* handleSetSavedReportTagData() {
  try {
    const env = process.env.REACT_APP_ENV;
    const jwtToken = yield call(getJwtToken);
    yield put(setTagSavingLoader(true));
    const savingTag = yield select(selectedReportTag);
    console.log("LOG: savingReportResultTag: ", savingTag);

    const now = new Date();
    const utcDateTime = now.toISOString().slice(0, 19).replace('T', ' ');
    const username = yield call(getLocalStorageItem, 'username');
    const email = yield call(getLocalStorageItem, 'email');
    const reportId = savingTag.report_id;
    const fileName = !savingTag.file_name ? "false" : savingTag.file_name.split(".")[0];
    const fileUrl = !savingTag.file_url ? "false" : savingTag.file_url;
    const occurredDatetime = savingTag.occurred_datetime.slice(0, 19).replace('T', ' ');
    const gameSpaceId = savingTag.game_space_id;
    const photoOfPowerAssetId = savingTag.power_asset_id;
    const placeCode = savingTag.place_code;
    const signNumber = savingTag.sign_number;
    const equipmentNumber = savingTag.equipment_number;
    const playerId = savingTag.player_id;
    const playerName = savingTag.player_name;
    const tagArryString = JSON.stringify(savingTag.tags);
    const tagCommaString = savingTag.tags.map(String).join(',');
    const resultTagArryString = JSON.stringify(savingTag.result_tags);
    const resultTagCommaString = savingTag.result_tags.map(String).join(',');

    const table = env === 'prod' ? "PicTreeViewerReportTagProd" : "PicTreeViewerReportTagDev";
    const sqlQueryGetReportResultTag = {
      query: `
        SELECT * FROM ${table} WHERE user_email = '${email}' AND report_id = '${reportId}';
      `,
      type: "select"
    };

    const [getReportResultTagDataTemp] =
      yield all([
        call(
          getDataFromKpiDash,
          sqlQueryGetReportResultTag,
          ENDPOINT.GET_DATA_KPIDASH_API
        ),
      ]);

    if (getReportResultTagDataTemp.length > 0) {
      // UPDATE
      const sqlQueryUpdateReportResultTag = {
        query: `
          UPDATE ${table}
          SET result_tag_array = '${resultTagArryString}', result_tag_flat = '${resultTagCommaString}', logDate = '${utcDateTime}'
          WHERE user_email = '${email}' AND report_id = '${reportId}';
        `,
        type: "write"
      };
      const [updateReportResultTagDataTemp] =
        yield all([
          call(
            getDataFromKpiDash,
            sqlQueryUpdateReportResultTag,
            ENDPOINT.GET_DATA_KPIDASH_API
          ),
        ]);
    } else {
      // INSERT
      const sqlQueryReportResultSetTag = {
        query: `
          INSERT INTO ${table}
          (user_id, user_email, report_id, file_name, file_url, occurred_datetime, game_space_id, photo_of_power_asset_id, place_code, sign_number, equipment_number, player_id, player_name, tag_array, tag_flat, result_tag_array, result_tag_flat, private, logDate) VALUES ('${username}', '${email}', '${reportId}', '${fileName}', '${fileUrl}', '${occurredDatetime}', '${gameSpaceId}', '${photoOfPowerAssetId}', '${placeCode}', '${signNumber}','${equipmentNumber}', '${playerId}', '${playerName}', '${tagArryString}', '${tagCommaString}', '${resultTagArryString}', '${resultTagCommaString}', 0, '${utcDateTime}');
        `,
        type: "write"
      };
      const [setTagDataTemp] =
        yield all([
          call(
            getDataFromKpiDash,
            sqlQueryReportResultSetTag,
            ENDPOINT.GET_DATA_KPIDASH_API
          ),
        ]);
    }
    yield put(setTagSavingLoader(false));
  } catch (error) {
    console.log(error);
  }
}

export function* handleGetSavedReportTagDataByReportId(action) {
  try {
    const env = process.env.REACT_APP_ENV;
    const email = yield call(getLocalStorageItem, 'email');
    const reportId = action.payload;
    const table = env === 'prod' ? "PicTreeViewerReportTagProd" : "PicTreeViewerReportTagDev";
    const sqlQueryGetTag = {
      query: `
        SELECT * FROM ${table} WHERE report_id = '${reportId}';
      `,
      type: "select"
    };
    const [getTagDataTemp] =
      yield all([
        call(
          getDataFromKpiDash,
          sqlQueryGetTag,
          ENDPOINT.GET_DATA_KPIDASH_API
        ),
      ]);
    if (getTagDataTemp.length > 0) {
      const savedTagData = {
        result_tags: JSON.parse(getTagDataTemp[0][16]["stringValue"]),  // Array of selected tags
      }
      yield put(setSelectedReportTag(savedTagData));
    }
    yield put(setTagSavingLoader(false));
  } catch (error) {
    console.log(error);
  }
}

export function* handleSetSavedTagDataNtt() {
  try {
    const env = process.env.REACT_APP_ENV;
    const jwtToken = yield call(getJwtToken);
    yield put(setTagSavingLoader(true));
    const savingTag = yield select(selectedTagNtt);

    const now = new Date();
    const utcDateTime = now.toISOString().slice(0, 19).replace('T', ' ');
    const username = yield call(getLocalStorageItem, "username");
    const email = yield call(getLocalStorageItem, "email");

    const table = env === 'prod' ? "PicTreeViewerResultTagNttProd" : "PicTreeViewerResultTagNttDev";

    const {
      fileName,
      object_key,
      occurred_datetime,
      game_space_id,
      player_id,
      player_name,
      review_request_id,
      power_asset_id,
      power_asset_photography_target_id,
      game_term_id,
      game_field_id,
      prefectural_area,
      exchange_office_name,
      asset_info,
      photography_target,
      tags, // "true" / "false" / "pending"
      reject_reason,
      latitude,
      longitude,
      sub_type,
    } = savingTag;

    const occurredDatetime = occurred_datetime?.slice(0, 19).replace('T', ' ');

    // Step 1: check if record exists
    const sqlQueryCheck = {
      query: `
        SELECT COUNT(*) FROM ${table}
        WHERE player_id = '${player_id}'
          AND review_request_id = '${review_request_id}';
      `,
      type: "select"
    };

    const [existingRows] = yield all([
      call(getDataFromKpiDash, sqlQueryCheck, ENDPOINT.GET_DATA_KPIDASH_API),
    ]);

    if (existingRows[0][0]["longValue"] == 1) {
      // Step 2: UPDATE
      const sqlQueryUpdate = {
        query: `
          UPDATE ${table}
          SET tag = '${tags}',
              reject_reason = ${reject_reason ? `'${reject_reason}'` : 'NULL'},
              user_id = '${username}',
              user_email = '${email}',
              log_date = '${utcDateTime}'
          WHERE file_name = '${fileName}'
            AND player_id = '${player_id}'
            AND review_request_id = '${review_request_id}';
        `,
        type: "write"
      };

      yield all([
        call(getDataFromKpiDash, sqlQueryUpdate, ENDPOINT.GET_DATA_KPIDASH_API),
      ]);
    } else {
      const sqlQueryInsert = {
        query: `
          INSERT INTO ${table} (
            file_name,
            object_key,
            occurred_datetime,
            game_space_id,
            player_id,
            player_name,
            review_request_id,
            power_asset_id,
            power_asset_photography_target_id,
            game_term_id,
            game_field_id,
            prefectural_area,
            exchange_office_name,
            asset_info,
            photography_target,
            tag,
            reject_reason,
            user_id,
            user_email,
            log_date,
            latitude,
            longitude,
            sub_type
          ) VALUES (
            '${fileName}',
            '${object_key}',
            '${occurredDatetime}',
            '${game_space_id}',
            '${player_id}',
            '${player_name}',
            '${review_request_id}',
            '${power_asset_id}',
            '${power_asset_photography_target_id}',
            '${game_term_id}',
            '${game_field_id}',
            '${prefectural_area}',
            '${exchange_office_name}',
            '${asset_info}',
            '${photography_target}',
            '${tags}',
            ${reject_reason ? `'${reject_reason}'` : 'NULL'},
            '${username}',
            '${email}',
            '${utcDateTime}',
            ${latitude},
            ${longitude},
            '${sub_type}'
          );
        `,
        type: "write"
      };

      yield all([
        call(getDataFromKpiDash, sqlQueryInsert, ENDPOINT.GET_DATA_KPIDASH_API),
      ]);
    }

    yield put(setTagSavingLoader(false));
  } catch (error) {
    console.error("handleSetSavedTagDataNtt ERROR:", error);
    yield put(setTagSavingLoader(false));
  }
}

export function* handleGetSavedTagDataByFileNameNtt(action) {
  try {
    const env = process.env.REACT_APP_ENV;
    const email = yield call(getLocalStorageItem, 'email');
    const fileName = action.payload;
    const table = env === 'prod' ? "PicTreeViewerResultTagNttProd" : "PicTreeViewerResultTagNttDev";
    const sqlQueryGetTag = {
      query: `
        SELECT * FROM ${table} WHERE review_request_id = '${fileName}';
      `,
      type: "select"
    };
    const [getTagDataTemp] =
      yield all([
        call(
          getDataFromKpiDash,
          sqlQueryGetTag,
          ENDPOINT.GET_DATA_KPIDASH_API
        ),
      ]);

    if (getTagDataTemp.length > 0) {
      const savedTagData = {
        fileName: getTagDataTemp[0][1]["stringValue"], //row.fileName
        tags: getTagDataTemp[0][16]["stringValue"],  // Array of selected tags
        reject_reason: getTagDataTemp[0][16]["stringValue"] === "false" ? getTagDataTemp[0][17]["stringValue"] : "",
      }
      yield put(setSelectedTagNtt(savedTagData)); // Fill up
    }
    yield put(setTagSavingLoader(false));
  } catch (error) {
    console.log(error);
  }
}

export function* handleSetSavedCommentDataHokuden() {
  try {
    const env = process.env.REACT_APP_ENV;
    yield put(setCommentSavingLoader(true));
    const savingComment = yield select(assetComment);

    const now = new Date();
    const utcDateTime = now.toISOString().slice(0, 19).replace('T', ' ');
    const fileName = savingComment.fileName;
    const objectKey = savingComment.object_key;
    const occurredDatetime = savingComment.occurred_datetime.slice(0, 19).replace('T', ' ');
    const gameSpaceId = savingComment.game_space_id;
    const gameSpaceType = savingComment.game_space_type;
    const reviewRequestId = savingComment.review_request_id;
    const photoOfPowerAssetId = savingComment.photo_of_power_asset_id;
    const powerPoleNumber = savingComment.power_pole_number;
    const cityName = savingComment.city_name;
    const cityCode = savingComment.city_code;
    const branchCode = savingComment.branch_code;
    const playerId = savingComment.player_id;
    const playerName = savingComment.player_name;
    const comment = savingComment.comment;
    const username = yield call(getLocalStorageItem, 'username');
    const email = yield call(getLocalStorageItem, 'email');

    const table = env === 'prod' ? "PicTreeViewerCommentHokudenProd" : "PicTreeViewerCommentHokudenDev";
    const sqlQueryGetComment = {
      query: `
        SELECT * FROM ${table} WHERE user_email = '${email}' AND file_name = '${fileName}';
      `,
      type: "select"
    };

    const [getCommentDataTemp] =
      yield all([
        call(
          getDataFromKpiDash,
          sqlQueryGetComment,
          ENDPOINT.GET_DATA_KPIDASH_API
        ),
      ]);

    if (getCommentDataTemp.length > 0) {
      // UPDATE
      const sqlQueryUpdateComment = {
        query: `
          UPDATE ${table}
          SET comment = '${comment}', logDate = '${utcDateTime}'
          WHERE user_email = '${email}' AND file_name = '${fileName}';
        `,
        type: "write"
      };
      const [updateCommentDataTemp] =
        yield all([
          call(
            getDataFromKpiDash,
            sqlQueryUpdateComment,
            ENDPOINT.GET_DATA_KPIDASH_API
          ),
        ]);
    } else {
      // INSERT
      const sqlQuerySetComment = {
        query: `
          INSERT INTO ${table}
          (user_id, user_email, file_name, object_key, occurred_datetime, game_space_id, game_space_type, review_request_id, photo_of_power_asset_id, power_pole_number, city_name, city_code, branch_code, player_id, player_name, comment, private, logDate) VALUES ('${username}', '${email}', '${fileName}', '${objectKey}', '${occurredDatetime}', '${gameSpaceId}', '${gameSpaceType}','${reviewRequestId}', '${photoOfPowerAssetId}', '${powerPoleNumber}', '${cityName}','${cityCode}', '${branchCode}', '${playerId}', '${playerName}', '${comment}', 0, '${utcDateTime}');
        `,
        type: "write"
      };
      console.log("LOG sqlQuerySetComment:", sqlQuerySetComment.query);
      const [setCommentDataTemp] =
        yield all([
          call(
            getDataFromKpiDash,
            sqlQuerySetComment,
            ENDPOINT.GET_DATA_KPIDASH_API
          ),
        ]);
      console.log("LOG setCommentDataTemp:", setCommentDataTemp);
    }
    yield put(setCommentSavingLoader(false));
  } catch (error) {
    console.log(error);
  }
}

export function* handleGetSavedCommentDataByFileNameHokuden(action) {
  try {
    const env = process.env.REACT_APP_ENV;
    const email = yield call(getLocalStorageItem, 'email');
    const fileName = action.payload;
    const table = env === 'prod' ? "PicTreeViewerCommentHokudenProd" : "PicTreeViewerCommentHokudenDev";
    const sqlQueryGetTag = {
      query: `
        SELECT * FROM ${table} WHERE user_email = '${email}' AND file_name = '${fileName}';
      `,
      type: "select"
    };
    const [getCommentDataTemp] =
      yield all([
        call(
          getDataFromKpiDash,
          sqlQueryGetTag,
          ENDPOINT.GET_DATA_KPIDASH_API
        ),
      ]);
    if (getCommentDataTemp.length > 0) {
      yield put(setAssetComment(getCommentDataTemp[0][16]["stringValue"])); // Fill up
    }
  } catch (error) {
    console.log(error);
  }
}


export default function* watchMapSettings() {
  yield takeEvery(APP.GET_SEASON_DATA, handleSeasonData);
  yield takeEvery(APP.GET_MISSION_DATA, handleMissionData);
  yield takeEvery(APP.SET_SAVED_SELECTED_TAG_DATA, handleSetSavedTagData);
  yield takeEvery(APP.GET_SAVED_SELECTED_TAG_DATA_BY_FILENAME, handleGetSavedTagDataByFileName);
  yield takeEvery(APP.SET_SAVED_COMMENT_DATA, handleSetSavedCommentData);
  yield takeEvery(APP.GET_SAVED_COMMENT_DATA_BY_FILENAME, handleGetSavedCommentDataByFileName);
  yield takeEvery(APP.SET_SAVED_SELECTED_REPORT_TAG_DATA, handleSetSavedReportTagData);
  yield takeEvery(APP.GET_SAVED_SELECTED_REPORT_TAG_DATA_BY_REPORT_ID, handleGetSavedReportTagDataByReportId);
  yield takeEvery(APP.SET_SAVED_SELECTED_TAG_DATA_NTT, handleSetSavedTagDataNtt);
  yield takeEvery(APP.GET_SAVED_SELECTED_TAG_DATA_BY_FILENAME_NTT, handleGetSavedTagDataByFileNameNtt);
  yield takeEvery(APP.SET_SAVED_COMMENT_DATA_HOKUDEN, handleSetSavedCommentDataHokuden);
  yield takeEvery(APP.GET_SAVED_COMMENT_DATA_BY_FILENAME_HOKUDEN, handleGetSavedCommentDataByFileNameHokuden);
}
